import VideoPlayer from './VideoPlayer';
import { VideoPlayerContext } from './context';
import VjsComponent from './VjsComponent';

VideoPlayer.Context = VideoPlayerContext;
export { VideoPlayerContext, VjsComponent };
export default VideoPlayer;
